import React, { Component } from 'react'
import $ from 'jquery'

var TEXTS = {
  'eia': {
    'name': 'Esma Isis-Arnautovic',
    'bio': 'Esma Isis-Arnautovic stammt ursprünglich aus Bosnien und lebt seit 1993 in der Schweiz. Dort hat sie Islamwissenschaften an der Universität Bern sowie Medien- und Kommunikationswissenschaften an der Universität Fribourg studiert. Derzeit arbeitet sie als Diplomassistentin  am Schweizerischen Zentrum für Islam und Gesellschaft in Fribourg, an dessen Aufbau sie mitwirkt. Ihr Dissertationsvorhaben ist im Themenfeld „Mensch und Koran“ angesiedelt.'
  },
  'hff': {
    'name': 'Hermann Fränkert-Fechter (ehemalig)',
    'bio': 'Hermann Fränkert-Fechter ist Religionspädagoge und Diplom-Pädagoge, arbeitet als Abteilungsleiter für Kategoriale Seelsorge im Erzbischöflichen Ordinariat Berlin. Ehrenamtlich ist er Vizepräsident des Bonifatiuswerkes der Deutschen Katholiken. Er gehört zu den Herausgebern des Buches "Wenn das Unfassbare eintritt. Erste Hilfe für die Seele in multikultureller und multireligiöser Gesellschaft" (Echter-Verlag).'
  },
  'hm': {
    'name': 'Hooria Mashhour',
    'bio': 'Nach langjähriger Tätigkeit beim jemenitischen Erziehungsministerium arbeitete Frau Hooria Mashhour beim UNISCO National Komitee. Danach engagierte Sie sich in verschiedenen Organisation für Frauenrechte, um die Ungleichbehandlung der Geschlechter zu bekämpfen und Frauen mehr Teilhabe in der Gesellschaft und auch der öffentlichkeit (Alyamania Newspaper) zu geben. Als der arabische Frühling auch den Jemen ergriff, wurde sie Sprecherin des Nationalen Revolutionsrates und war von 2011 bis 2014 Ministerin für Menschenrechte. Seit ihrer Flucht lebt sie in Heide (Schleswig-Holstein) und engagierte sich für andere Geflüchtete in der Region.'
  },
  'pjp': {
    'name': 'Jens Petzold',
    'bio': 'Pater Jens Petzold stammt aus Berlin und ist in der Schweiz aufgewachsen. Eine Reise nach Syrien führt ihn auch ins Kloster Mar Musa. Er schloss sich der dortigen auf interreligiöse Verständigung ausgerichteten Gemeinschaft an und legte 2000 dort seine Profess ab. In Rom studierte er an der Gregoriana Philosophie und Theologie und betrieb auch islamische Studien am PISAI. Seit 2011 ist er in Sulaymaniyah, im kurdischen Nordirak und hat das Kloster Maryam al-Adhra gegründet.'
  },
  'kh': {
    'name': 'Klaudia Höfig',
    'bio': 'Klaudia Höfig ist Dipl. Religionspädagogin und Leiterin des Internationalen Pastoralen Zentrums (IPZ) des Erzbistums Berlin in Neukölln. Sie organisiert das Projekt "Neue Nachbarn in der Diaspora", das in katholischen Gemeinden über den christlich-muslimischen Dialog und Kontakt informiert. Darüber hinaus ist sie im Vorstand der Beratungsstelle SOLWODI und ist mitverantwortlich für die Bildungsstätte JACK - für Migrantinnen und Flüchtlinge in Berlin und zudem Mitglied einer interreligiösen Dialoggruppe.'
  },
  'mg': {
    'name': 'Margareta Gruber',
    'bio': 'Margareta Gruber ist Franziskanerin und Professorin für Exegese des Neuen Testaments und Biblische Theologie an der Philosophisch-Theologischen Hochschule Vallendar (PTHV). Von 2009-2013 lebte und lehrte sie in Jerusalem an der Abtei Dormitio als Inhaberin des Laurentius-Klein-Lehrstuhls für Biblische und ökumenische Theologie und als Dekanin des Theologischen Studienjahres.'
  },
  'mvm': {
    'name': 'Marie von Manteuffel',
    'bio': "Marie von Manteuffel ist Rechtsanwältin in Berlin. Seit März 2016 setzt sie sich als Geschäftsführerin des 'Katholischen Forums Leben in der Illegalität' für die Verbesserung der Lebenssituation von Menschen ohne Aufenthaltstitel in Deutschland ein. 2010 arbeitete sie als wissenschaftliche Assistentin in Jerusalem. Im Jahr 2015 begann sie ihr Engagement für Bildungsprojekte im Libanon mit dem Ziel, Nothilfe mit Versöhnungsarbeit im Aufnahmestaat zu verbinden."
  },
  'mk': {
    'name': 'Milad Karimi',
    'bio': 'Milad Karimi kam mit 13 Jahren als Kriegsflüchtling aus Kabul nach Deutschland. Er studierte Philosophie und Islamwissenschaft in Freiburg und Neu Delhi und promovierte in Philosophie. Er übersetzte  den Koran ins Deutsche, gibt verschiedene Zeitschriften heraus und ist seit 2016 Professor für Kalam, islamische Mystik und Philosophie an der Universität Münster.'
  },
  'ts': {
    'name': 'Tobias Specker',
    'bio': 'Tobias Specker, geb. 1971 in Goch am Niederrhein. Nach der Promotion in Fundamentaltheologie über den französischen Philosophen Jean-Luc Marion trat er 2001 in den Jesuitenorden ein. Er arbeitete am Canisius Kolleg und vertrat die Bereiche „interreligiöser Dialog“ und „biblische Theologie“ am Heinrich-Pesch Haus in Ludwigshafen. Nach mehrjähriger Tätigkeit als Islambeauftragter der Diözese Speyer studierte er von 2010 bis 2013 in Frankfurt den neu gegründeten Studiengang „Islamische Studien“. 2014 verbrachte er ein halbes Jahr in Kenia, u.a. in der Arbeit mit Flüchtlingen, seit Oktober 2014 ist er Juniorprofessor der Stiftungsprofessur „Katholische Theologie im Angesicht des Islam“ an der Philosophisch-Theologischen Hochschule Sankt Georgen.'
  }
}

export default class Board extends Component {
  constructor (props) {
    super(props)
    this.state = {
      selectedMember: ''
    }
  }

  showBio (key, event) {
    $(document.querySelectorAll('.board-entry-bio--' + key)).toggle(1000)
  }

  render () {
    return <section id='kuratorium' className='board'>
             <h3 className='board-title'>Kuratorium</h3>
             {Object.entries(TEXTS).map((t) => {
                return <div key={t[0]} className='board-entry'>
                         <div className={'board-entry-name' + (this.state.selectedMember !== t[0] ? '' : ' board-entry-name--selected')} onClick={this.showBio.bind(this, t[0])}>
                           {t[1].name}
                         </div>
                         <div className={'board-entry-bio board-entry-bio--' + t[0]}>
                           {t[1].bio}
                         </div>
                       </div>
              })}
           </section>
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/board.js
 **/